import { render, staticRenderFns } from "./PageTherapistClient.vue?vue&type=template&id=6af4c112"
import script from "./PageTherapistClient.vue?vue&type=script&lang=js"
export * from "./PageTherapistClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports